import {useEffect, useState} from 'react'
import {empty,parseSnapshot,type Snapshot} from './protocol'
export * from './protocol'
import {demo} from './demo'
export {DEMO_STEPS} from './demo'
import {subscribeLive,isLiveHealthy} from './liveBus'
export function useNetwork(mode:'demo'|'live',targetId:string) {
 const [liveData,setLiveData]=useState<Snapshot>(empty),[demoData,setDemoData]=useState<Snapshot>(empty),[connected,setConnected]=useState(false),[step,setStep]=useState(0),[playing,setPlaying]=useState(true),[round,setRound]=useState(0),[startedAt,setStartedAt]=useState(()=>new Date().toISOString()),[error,setError]=useState(''),[lastSync,setLastSync]=useState<string|null>(null)
 function restart(){setRound(r=>r+1);setStartedAt(new Date().toISOString());setDemoData(empty);setStep(0);setPlaying(true)}
 useEffect(()=>{if(mode!=='demo')return;const next=demo(step,startedAt,round);setDemoData(old=>({...next,events:[...next.events,...old.events.filter(e=>e.id!==next.events[0].id)].slice(0,12)}))},[mode,step,startedAt,round])
 useEffect(()=>{if(mode!=='demo'||!playing)return;const t=setInterval(()=>{if(step===7)restart();else setStep(s=>s+1)},4500);return()=>clearInterval(t)},[mode,playing,step])
 useEffect(()=>{
  if(mode!=='live')return
  setLiveData(empty);setConnected(false);setError('');setLastSync(null)
  if(!targetId)return
  let stopped=false,busy=false,pending=false
  const lifecycle=new AbortController()
  const base=((import.meta as unknown as {env:Record<string,string>}).env.VITE_AIM_API_BASE || '').replace(/\/$/,'')
  const query=`?targetId=${encodeURIComponent(targetId)}`
  async function refresh(){
   if(stopped)return
   if(busy){pending=true;return}busy=true
   const request=new AbortController(),cancel=()=>request.abort();lifecycle.signal.addEventListener('abort',cancel)
   const timeout=setTimeout(()=>request.abort(),7000)
   try {
    const paths=[`/api/v1/targets/${encodeURIComponent(targetId)}/state`,`/api/v1/observers${query}`,`/api/v1/metrics${query}`,`/api/v1/events${query}`]
    const results=await Promise.all(paths.map(async path=>{const r=await fetch(base+path,{signal:request.signal,headers:{Accept:'application/json'},cache:'no-store'});if(!r.ok)throw Error(`HTTP ${r.status}`);return r.json()}))
    const snapshot=parseSnapshot(results,targetId)
    if(!stopped){setLiveData(snapshot);setConnected(isLiveHealthy());setLastSync(new Date().toISOString());setError('')}
   }catch{if(!stopped){setConnected(false);setError('No se pudo validar o actualizar la información de la red.')}}finally{clearTimeout(timeout);request.abort();lifecycle.signal.removeEventListener('abort',cancel);busy=false;if(pending&&!stopped){pending=false;void refresh()}}
  }
  // Shared SSE + poll fallback (apps/portal/src/aim/liveBus.ts) — see
  // docs/PORTAL_LIVE_REFRESH.md. Every LIVE panel subscribes to the same
  // signal instead of each opening its own EventSource/setInterval.
  void refresh()
  const unsubscribe=subscribeLive(base,()=>void refresh())
  return()=>{stopped=true;lifecycle.abort();unsubscribe()}
 },[mode,targetId])
 const data=mode==='demo'?demoData:liveData
 return {data,connected,step,setStep,playing,setPlaying,restart,lastSync,error,totalDetections:data.metrics.totalDetections}
}
